//
//
//
//
//
//

export default {
  name: 'clearSession',
  components: {
  },
  data () {
    return {
      msg:''
    }
  },
  created(){
    this.$func.setLocal('token','');
    this.$func.setLocal('node_v1','');
    this.$func.setLocal('grade','');
  },
  mounted(){
    this.msg = '缓存清理成功';
  },
  methods:{
  }
}



// WEBPACK FOOTER //
// ./src/pages/clearSession.vue